// filepath: c:\Users\greg\regulator\express\analysis-app\src\components\dashboard\charts\BaseChart.jsx
import React from 'react'
import Chart from 'react-apexcharts'

function BaseChart({ 
  series, 
  options, 
  type = 'line', 
  height = 120, 
  loading = false, 
  error = null,
  fallbackText = 'No data',
}) {
  // Common chart configuration
  const defaultOptions = {
    chart: {
      background: 'transparent',
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
      zoom: { enabled: false },
      selection: { enabled: false },
    },
    grid: {
      show: true,
      borderColor: '#e9ecef',
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
      padding: { top: 5, right: 5, bottom: 5, left: 5 },
    },
    legend: { show: false },
    tooltip: {
      enabled: true,
      theme: 'light',
      style: {
        fontSize: '12px',
        fontFamily: 'inherit',
      },
    },
    responsive: [{
      breakpoint: 576,
      options: {
        chart: { height: 100 },
      },
    }],
  }

  // Merge default options with provided options
  const chartOptions = {
    ...defaultOptions,
    ...options,
    chart: {
      ...defaultOptions.chart,
      ...options?.chart,
    },
    grid: {
      ...defaultOptions.grid,
      ...options?.grid,
    },
  }

  // Loading state
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height }}>
        <div className="spinner-border spinner-border-sm text-secondary" role="status">
          <span className="visually-hidden">Loading chart...</span>
        </div>
      </div>
    )
  }

  // Error state
  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center text-muted" style={{ height }}>
        <small>Chart error</small>
      </div>
    )
  }

  // No data state
  if (!series || series.length === 0 || (series[0]?.data && series[0].data.length === 0)) {
    return (
      <div className="d-flex justify-content-center align-items-center text-muted" style={{ height }}>
        <small>{fallbackText}</small>
      </div>
    )
  }

  return (
    <Chart
      options={chartOptions}
      series={series}
      type={type}
      height={height}
    />
  )
}

export default React.memo(BaseChart)
